import React, { useContext, useState } from "react";
import AdvisorNavbar from "../layout/AdvisorNavbar";
import LocContext from "../context/locContext";
import { useNavigate } from "react-router-dom";
import { FiMessageSquare, FiPlus, FiSearch, FiFilter, FiEye, FiFileText, FiClock, FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";

export default function ClientTickets() {
  const { userData } = useContext(LocContext);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [showCreateForm, setShowCreateForm] = useState(false);

  const [ticketForm, setTicketForm] = useState({
    clientId: "",
    subject: "",
    category: "General",
    priority: "Medium",
    description: "",
    addInternalNote: false,
    internalNote: "",
  });

  const [tickets] = useState([
    {
      id: 1,
      ticketId: "TKT-001",
      clientName: "Rajesh Kumar",
      subject: "KYC Document Upload Issue",
      category: "KYC",
      priority: "High",
      status: "Open",
      createdAt: "2024-01-15",
      lastUpdated: "2 hours ago",
      messages: 3,
    },
    {
      id: 2,
      ticketId: "TKT-002",
      clientName: "Priya Sharma",
      subject: "Investment Query",
      category: "Investment",
      priority: "Medium",
      status: "In Progress",
      createdAt: "2024-01-14",
      lastUpdated: "1 day ago",
      messages: 5,
    },
    {
      id: 3,
      ticketId: "TKT-003",
      clientName: "Amit Patel",
      subject: "Bank Account Verification",
      category: "Banking",
      priority: "High",
      status: "Resolved",
      createdAt: "2024-01-10",
      lastUpdated: "3 days ago",
      messages: 8,
    },
  ]);

  const filteredTickets = tickets.filter(ticket => {
    const matchesSearch = ticket.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticket.clientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticket.ticketId.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterStatus === "all" || ticket.status.toLowerCase() === filterStatus.toLowerCase();
    return matchesSearch && matchesFilter;
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setTicketForm(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCreateTicket = (e) => {
    e.preventDefault();
    Swal.fire({
      icon: "success",
      title: "Ticket Created!",
      text: "Support ticket has been created successfully.",
      customClass: {
        popup: "custom-swal-popup",
      },
    });
    setShowCreateForm(false);
    setTicketForm({
      clientId: "",
      subject: "",
      category: "General",
      priority: "Medium",
      description: "",
      addInternalNote: false,
      internalNote: "",
    });
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "High":
        return "#ef4444";
      case "Medium":
        return "#f59e0b";
      case "Low":
        return "#10b981";
      default:
        return "#64748b";
    }
  };

  return (
    
    <>
    <AdvisorNavbar />
    <div className="page-content" style={{ background: "#f1f5f9" }}>

          {/* Header */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px" }}>
            {/* <div style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
              padding: "20px",
              borderRadius: "12px",
              borderBottom: "3px solid #39b2b4",
            }}> */}
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <h2 className="mb-1" >
                    Client Tickets
                  </h2>
                 <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/agent/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">Client Tickets</li>
                </ol>
              </nav>  
                </div>
                <button
                  className="btn btn-primary"
                  onClick={() => setShowCreateForm(!showCreateForm)}
                  style={{
                    // background: "linear-gradient(135deg, # 0%, #39b2b4 100%)",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FiPlus style={{ fontSize: "18px" }} />
                  Create Ticket
                </button>
              </div>
            {/* </div> */}
          </div>

          {/* Create Ticket Form */}
          {showCreateForm && (
            <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "none" }}>
              <div className="card-body p-4">
                <div style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  padding: "16px",
                  borderRadius: "12px",
                  borderBottom: "3px solid #39b2b4",
                  marginBottom: "24px",
                }}>
                  <h4 className="mb-0" >
                    Create New Ticket
                  </h4>
                </div>

                <form onSubmit={handleCreateTicket}>
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                        Client <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        name="clientId"
                        value={ticketForm.clientId}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "8px",
                          border: "2px solid #e2e8f0",
                          fontSize: "14px",
                        }}
                        required
                      >
                        <option value="">Select Client</option>
                        <option value="1">Rajesh Kumar</option>
                        <option value="2">Priya Sharma</option>
                        <option value="3">Amit Patel</option>
                      </select>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                        Category <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        name="category"
                        value={ticketForm.category}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "8px",
                          border: "2px solid #e2e8f0",
                          fontSize: "14px",
                        }}
                        required
                      >
                        <option value="General">General</option>
                        <option value="KYC">KYC</option>
                        <option value="Investment">Investment</option>
                        <option value="Banking">Banking</option>
                        <option value="Technical">Technical</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                        Subject <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="subject"
                        value={ticketForm.subject}
                        onChange={handleInputChange}
                        placeholder="Enter ticket subject"
                        style={{
                          borderRadius: "8px",
                          border: "2px solid #e2e8f0",
                          fontSize: "14px",
                        }}
                        required
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                        Priority
                      </label>
                      <select
                        className="form-select"
                        name="priority"
                        value={ticketForm.priority}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "8px",
                          border: "2px solid #e2e8f0",
                          fontSize: "14px",
                        }}
                      >
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                        <option value="High">High</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                        Description <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <textarea
                        className="form-control"
                        name="description"
                        value={ticketForm.description}
                        onChange={handleInputChange}
                        rows="4"
                        placeholder="Enter ticket description"
                        style={{
                          borderRadius: "8px",
                          border: "2px solid #e2e8f0",
                          fontSize: "14px",
                        }}
                        required
                      />
                    </div>

                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="addInternalNote"
                          id="addInternalNote"
                          checked={ticketForm.addInternalNote}
                          onChange={handleInputChange}
                          style={{
                            borderRadius: "4px",
                            border: "2px solid #e2e8f0",
                          }}
                        />
                        <label className="form-check-label" htmlFor="addInternalNote" style={{ color: "#64748b", fontSize: "14px" }}>
                          Add Internal Note (Visible only to agents)
                        </label>
                      </div>
                    </div>

                    {ticketForm.addInternalNote && (
                      <div className="col-12">
                        <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                          Internal Note
                        </label>
                        <textarea
                          className="form-control"
                          name="internalNote"
                          value={ticketForm.internalNote}
                          onChange={handleInputChange}
                          rows="3"
                          placeholder="Enter internal note"
                          style={{
                            borderRadius: "8px",
                            border: "2px solid #e2e8f0",
                            fontSize: "14px",
                          }}
                        />
                      </div>
                    )}

                    <div className="col-12">
                      <div className="d-flex gap-2">
                        <button
                          type="submit"
                          className="btn btn-primary"
                 
                        >
                          Create Ticket
                        </button>
                        <button
                          type="button"
                          className="btn"
                          onClick={() => setShowCreateForm(false)}
                          style={{
                            background: "#f1f5f9",
                            color: "#64748b",
                            border: "none",
                            borderRadius: "8px",
                            padding: "10px 24px",
                            fontWeight: "500",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Search and Filter */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px" }}>
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <div className="position-relative">
                  <FiSearch style={{
                    position: "absolute",
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#64748b",
                    fontSize: "20px",
                  }} />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by subject, client name, or ticket ID..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      paddingLeft: "40px",
                      borderRadius: "8px",
                      border: "2px solid #e2e8f0",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>
              <div className="col-12 col-md-3">
                <select
                  className="form-select"
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  style={{
                    borderRadius: "8px",
                    border: "2px solid #e2e8f0",
                    fontSize: "14px",
                  }}
                >
                  <option value="all">All Status</option>
                  <option value="open">Open</option>
                  <option value="in progress">In Progress</option>
                  <option value="resolved">Resolved</option>
                </select>
              </div>
            </div>
          </div>

          {/* Tickets List */}
          <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
            <div className="card-body p-4">
              <div style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                padding: "16px",
                borderRadius: "12px",
                borderBottom: "3px solid #39b2b4",
                marginBottom: "24px",
              }}>
                <h4 className="mb-0" >
                  Tickets List
                </h4>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr style={{ background: "#f8fafc" }}>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Ticket ID</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Client Name</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Subject</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Category</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Priority</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Status</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Last Updated</th>
                      <th style={{ color: "#", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTickets.map((ticket) => (
                      <tr key={ticket.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                        <td style={{ padding: "12px", color: "#", fontWeight: "600" }}>{ticket.ticketId}</td>
                        <td style={{ padding: "12px", color: "#1e293b", fontWeight: "500" }}>{ticket.clientName}</td>
                        <td style={{ padding: "12px", color: "#1e293b" }}>{ticket.subject}</td>
                        <td style={{ padding: "12px" }}>
                          <span className="badge" style={{
                            background: "#e0f2fe",
                            color: "#0369a1",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}>
                            {ticket.category}
                          </span>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <span className="badge" style={{
                            background: getPriorityColor(ticket.priority) + "20",
                            color: getPriorityColor(ticket.priority),
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}>
                            {ticket.priority}
                          </span>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <span className="badge" style={{
                            background: ticket.status === "Resolved" ? "#d1fae5" : ticket.status === "In Progress" ? "#dbeafe" : "#fef3c7",
                            color: ticket.status === "Resolved" ? "#10b981" : ticket.status === "In Progress" ? "#2563eb" : "#f59e0b",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}>
                            {ticket.status}
                          </span>
                        </td>
                        <td style={{ padding: "12px", color: "#64748b", fontSize: "14px" }}>
                          <div className="d-flex align-items-center">
                            <FiClock style={{ fontSize: "14px", marginRight: "4px" }} />
                            {ticket.lastUpdated}
                          </div>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <button
                            className="btn btn-sm"
                            onClick={() => navigate(`/support/ticket-detail/${ticket.id}`)}
                            style={{
                              background: "linear-gradient(135deg, #ccf1f7 0%, #b3eaf4 100%)",
                              color: "#",
                              border: "none",
                              borderRadius: "6px",
                              padding: "15px",
                              fontSize: "12px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <FiEye style={{ fontSize: "14px" ,color: "#1bafb4" }} />
                            {/* View */}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    </>
  );
}
